import PropTypes from 'prop-types';
import {Component} from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import {Header, Icon, Image} from 'semantic-ui-react';
import deleteIcon from '../images/delete-icon.svg';
import editIcon from '../images/editIcon.svg';
import './CustomiseTestimonials.scss';
import {DragHandle} from './DragHandle';
import './TestimonialView.scss';

export default class TestimonialView extends Component {
  static propTypes = {
    testimonial: PropTypes.object,
    edit: PropTypes.func.isRequired,
    remove: PropTypes.func.isRequired
  };

  render() {
    const {testimonial, edit, remove} = this.props;
    return (
      <div className="testimonial-view">
        <DragHandle/>
        <div className="button-bar">
          <Image className="edit" src={editIcon} onClick={edit}/>
          <Image className="delete" src={deleteIcon} onClick={() => remove(this.props.testimonial)}/>
        </div>
        {testimonial.title && <Header as="h3" className="view-title">{testimonial.title}</Header>}
        {(testimonial.image || testimonial.description) && <div className="image-description">
          {testimonial.image && <Image src={testimonial.image}/>}
          {testimonial.description &&
            <div className="text">
              <Icon name="quote left" color="grey" className="open-quote"/>
              {testimonial.description}
              <Icon name="quote right" color="grey" className="close-quote"/>
            </div>}
        </div>}
        {testimonial.author && <Header as="h3" className="author">{testimonial.author}</Header>}
        <div className="month-year">
          {testimonial.month && <span className="month">{testimonial.month}</span>}
          {testimonial.year && <span className="year">{testimonial.year}</span>}
        </div>
      </div>
    );
  }
}
